import { render, staticRenderFns } from "./Dialog_TeacherCargoShop.vue?vue&type=template&id=01afdd21&scoped=true&"
import script from "./Dialog_TeacherCargoShop.vue?vue&type=script&lang=js&"
export * from "./Dialog_TeacherCargoShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01afdd21",
  null
  
)

export default component.exports